interface Props {
    text: string;
    value: string;
    onClick: (value: string) => void;
}

export const Example = ({ text, value, onClick }: Props) => {
    return (
        <button className="sstl-primary-button w-56 h-full" onClick={() => onClick(value)}>
            <span className="whitespace-normal normal-case text-left text-sm p-4">
                <span>{text}</span>
            </span>
        </button>
    );
};
